import { Col, Input, Row } from "reactstrap";
import styles from "./Personal.module.scss";
import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown";
import Checkbox from "../../../../../components/common/Checkbox/Checkbox";
import NoProfileImage from "../../../../../assets/images/SellerPortalImages/Settings/no-profile.png";
import Plus from "../../../../../assets/images/SellerPortalImages/Settings/plus.svg";
import { useState } from "react";
import { MdDelete } from "react-icons/md";

const Personal = () => {
  const [profilePic, setProfilePic] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfilePic(file);
    }
  };

  const clearProfilePic = () => {
    setProfilePic(null);
  };

  return (
    <div className="py-3">
      <div className={styles["heading"]}>Personal Information</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xxl={2}>Seller ID</Col>
            <Col lg={5} xxl={4}>SDHFKJ45</Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xxl={2}>Your full name</Col>
            <Col lg={5} xxl={4}>
              <Input placeholder="Enter Full Name" />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xxl={2}>Phone number:</Col>
            <Col lg={5} xxl={4}>
              <Input type="number" placeholder="Enter phone" />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xxl={2}>Email Address:</Col>
            <Col lg={5} xxl={4}>
              <Input type="text" placeholder="Enter email" />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xxl={2}>Gender</Col>
            <Col lg={5} xxl={4}>
              <div className="border rounded p-2">
                <CustomDropdown title={"Select from dropdown"} muted />
              </div>
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xxl={2}>Vacation Mode:</Col>
            <Col lg={5} xxl={4}>
              <div className="d-flex gap-3">
                <div className="d-flex align-items-center gap-1">
                  <label htmlFor="vacationModeYes">Yes</label>
                  <Checkbox id="vacationModeYes" name="vacationModeYes" />
                </div>
                <div className="d-flex align-items-center gap-1">
                  <label htmlFor="vacationModeNo">No</label>
                  <Checkbox id="vacationModeNo" name="vacationModeNo" />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xxl={2}>Vacation Period:</Col>
            <Col lg={6} xxl={5}>
              <Row className="g-0">
                <Col lg="5">
                  <div>
                    <Input type="date" />
                  </div>
                </Col>
                <Col
                 lg="2"
                  className="d-flex align-items-center justify-content-center"
                >
                  <b>-</b>
                </Col>
                <Col lg="5">
                  <div>
                    <Input type="date" />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>

      <div className={styles["heading"]}>Profile Picture</div>
      <div className="p-2 bg-white">
        <div className="border border-subtle-secondary p-3">
          <Row className="g-0">
            <Col lg={3} xxl={2} className="d-flex flex-column align-items-center gap-2">
              <div className={styles["no-profile-pic"]}>
                <img
                  src={
                    profilePic
                      ? URL.createObjectURL(profilePic)
                      : NoProfileImage
                  }
                  className={styles["profile"]}
                  alt="Profile Preview"
                />
                {profilePic ? (
                  <MdDelete
                    className={styles["delete"]}
                    size={24}
                    onClick={clearProfilePic}
                  />
                ) : (
                  <label htmlFor="profilePic">
                    <img src={Plus} alt="" className={styles["plus"]} />
                  </label>
                )}
              </div>

              <div className={styles.label}>Add Profile Picture</div>
              <input
                id="profilePic"
                type="file"
                accept="image/*"
                className="d-none"
                onChange={handleFileChange}
              />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Personal;